import {SalesPgStep} from '../../enums/sales-pg-step.enum';
import {PgCalculationRequest, PgCalculationResult, PgCreatePolicyRequest} from '../../models/sales-pg.model';
import {FilledQuestionnaire} from '../../models/questionnaire.model';

export namespace SalesPgActions {

    export class SetActiveStep {
        static readonly type = 'SalesPgActions.SetActiveStep';

        constructor(public activeStep: SalesPgStep) {
        }
    }

    export class GetAvailability {
        static readonly type = 'SalesPgActions.GetAvailability';
    }

    export class GetQuestionnaire {
        static readonly type = 'SalesPgActions.GetQuestionnaire';
    }

    export class ValidateQuestionnaire {
        static readonly type = 'SalesPgActions.ValidateQuestionnaire';

        constructor(public payload: FilledQuestionnaire) {
        }
    }

    export class CalculationRequest {
        static readonly type = 'SalesPgActions.CalculationRequest';

        constructor(public payload: PgCalculationRequest) {
        }
    }

    export class ClausesRequest {
        static readonly type = 'SalesPgActions.ClausesRequest';

        constructor(public payload: PgCalculationResult) {
        }
    }

    export class CreatePolicyRequest {
        static readonly type = 'SalesPgActions.CreatePolicyRequest';

        constructor(public payload: PgCreatePolicyRequest) {
        }
    }

    export class ClearForm {
        static readonly type = 'SalesPgActions.ClearForm';
    }
}
